import { render } from "./CiCell.vue?vue&type=template&id=2cd93e02&scoped=true"
import script from "./CiCell.vue?vue&type=script&lang=js"
export * from "./CiCell.vue?vue&type=script&lang=js"

import "./CiCell.vue?vue&type=style&index=0&id=2cd93e02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd93e02"]])

export default __exports__